import { Colors } from "../../styles/theme";

const styles = {
  PlanBox_container: {
    backgroundColor: Colors.white,
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "stretch",
    border: "1px solid #D7E1EF",
    borderRadius: "8px",
    boxShadow: "0 12px 28px rgba(34, 49, 78, 0.05)",
    minHeight: 330,
    overflow: "hidden",
    textAlign: "start",
  },
  PlanBox_pricePanel: {
    backgroundColor: "#355F96",
    color: Colors.white,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: "0 0 330px",
    gap: "34px",
    padding: { xs: "28px", sm: "34px", md: "36px 30px" },
  },
  PlanBox_badge: {
    alignSelf: "flex-start",
    backgroundColor: "rgba(255, 255, 255, 0.13)",
    border: "1px solid rgba(255, 255, 255, 0.24)",
    borderRadius: "8px",
    color: Colors.white,
    fontSize: "0.9rem",
    fontWeight: 800,
    lineHeight: 1,
    px: 2,
    py: 1.1,
  },
  PlanBox_offer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  PlanBox_price: {
    color: Colors.white,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    columnGap: "10px",
    rowGap: "8px",
    fontSize: { xs: "3.2rem", sm: "4rem" },
    fontWeight: 800,
    lineHeight: 0.95,
    letterSpacing: 0,
    margin: 0,
    whiteSpace: "nowrap",
  },
  PlanBox_currency: {
    color: "rgba(255, 255, 255, 0.86)",
    display: "inline-block",
    fontSize: { xs: "0.88rem", sm: "1rem" },
    fontWeight: 800,
    lineHeight: 1.2,
    maxWidth: "100%",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
  },
  PlanBox_introPeriod: {
    color: "rgba(255, 255, 255, 0.9)",
    fontSize: "1.12rem",
    fontWeight: 700,
    lineHeight: 1.4,
    margin: 0,
  },
  PlanBox_regularBilling: {
    color: "rgba(255, 255, 255, 0.88)",
    fontSize: "1rem",
    fontWeight: 800,
    lineHeight: 1.45,
    margin: 0,
  },
  PlanBox_button: {
    width: "100%",
    minHeight: "52px",
    border: "1px solid #D7E1EF",
    borderRadius: "8px",
    boxShadow: "none",
    fontSize: { xs: "1rem", sm: "1.125rem" },
    fontWeight: 800,
    justifyContent: "center",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#F3F6FA",
      boxShadow: "none",
    },
  },
  PlanBox_buttonIcon: {
    fontSize: 20,
    marginInlineStart: "6px",
  },
  PlanBox_featuresPanel: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    justifyContent: "center",
    padding: { xs: "30px 24px", md: "34px 36px 34px 42px" },
  },
  PlanBox_featuresTitle: {
    color: Colors.navy,
    fontSize: { xs: "1.8rem", md: "2rem" },
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1.15,
    margin: "0 0 18px",
  },
  PlanBox_featureColumns: {
    columnGap: { xs: "0px", md: "58px" },
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1fr) minmax(0, 1fr)" },
  },
  PlanBox_featureList: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    padding: 0,
  },
  PlanBox_checkCircle: {
    color: "#2D9363",
    fontSize: 19,
    strokeWidth: 3,
  },
  PlanBox_featureIcon: {
    minWidth: "34px",
    paddingTop: "1px",
  },
  PlanBox_featureText: {
    alignItems: "flex-start",
    color: Colors.text,
    padding: "8px 0",
  },
  PlanBox_featureCopy: {
    color: "#43566F",
    fontSize: { xs: "1rem", md: "1.05rem" },
    fontWeight: 650,
    lineHeight: 1.45,
    letterSpacing: 0,
  },
}
export default styles;
